import { OnInit, Component, OnDestroy, ViewChild, Output, EventEmitter } from "@angular/core";
import { select } from "@angular-redux/store";
import {
  DeleteToFromCapacity,
  ToOperationalStatusType,
  TransportOrder
} from "../../../../pb-screen/models/transport-order/transport-order.interface";
import { Observable, Subject } from "rxjs";
import { OrderLine } from "../../../../pb-screen/models/order-line/orderLine.interface";
import { ToScreenService } from "../../../../pb-screen/services/to-screen.service";
import { ActionWizardService } from "../../../../shared/services/action-wizard.service";
import { ApplicationUser } from "../../../../pb-screen/models/application.user.interface";
import { WizardDefinition } from "../../../../shared/models/wizard-definition";
import { InsertActionTemplateType } from "../../../../shared/models/insert-action-template-type";
import { HttpClientService } from "../../../../shared/services/httpclient";
import { SharedActions } from "../../../../shared/shared.actions";
import { ToActions } from "../../../to.actions";
import { ToActionBarService } from "../../../../pb-screen/services/to-action-bar.service";
import { PbScreenService } from "../../../../pb-screen/services/pb-screen.service";
import { PlanningBlock } from "../../../../pb-screen/models/planning-block/planning-block.interface";
import { takeUntil } from "rxjs/operators";
import { SimpleModalComponent, SimpleModalService } from "ngx-simple-modal";
import { ToInsertActionWizardComponent } from "../../../modals/to-insert-action-wizard-modal/to-insert-action-wizard-modal.component";
import { UserFeedbackService } from "../../../../services/user-feedback.service";
import { MapService } from "../../../../shared/services/map.service";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { ToOrderLinesComponent } from "./to-orderlines/to-orderlines.component";
import { ToActionBarComponent } from "../../to-action-bar/to-action-bar.component";
import {PlanningActionResult} from "../../../../shared/components/planningactions/planningactions-menu/planningactions-menu.component";
import {SelectionTypes} from "../../../../static/selection-types";

export interface ToDetailsModalResult {
  planningActionResult?: null | PlanningActionResult
}

@Component({
  moduleId: module.id,
  selector: 'to-details-modal',
  templateUrl: './to-details-modal.component.html',
  providers: [MapService]
})

export class ToDetailsComponent extends SimpleModalComponent<ToDetailsInput, ToDetailsModalResult> implements ToDetailsInput, OnInit, OnDestroy {
  @Output() public refreshTableDisplay = new EventEmitter();

  @select("toWizardDefinitions") toWizardDefinitions$: Observable<WizardDefinition[]>;
  @select("selectedPbsFromPlanBoard") selectedPbsFromPlanBoard$: Observable<PlanningBlock[]>;
  @select("selectionType") public selectionType$: Observable<string>;
  @select("selectedPbsToPlan") public selectedPbsToPlan$: Observable<PlanningBlock[]>;
  @select("loading") public loading$: Observable<boolean>;
  @select("selectedOrderlines") public selectedOrderlines$: Observable<OrderLine[]>; // add this

  public hasOrderlineSelection = false; // add this



  @ViewChild("toLinesGrid") toLinesGrid: ToOrderLinesComponent;
  @ViewChild("toActionBar") toActionBar: ToActionBarComponent;

  public orderLines: OrderLine[] = [];
  public selectedPlanningBlocks: PlanningBlock[];
  public finalizeCombi: boolean = false;
  public actionWizardsList: WizardDefinition[] = [];
  public selectedActionWizard: WizardDefinition = null;
  public filter: string = InsertActionTemplateType.toCard;
  public selectionType: string = "";
  public user: ApplicationUser;
  public defaultPlanningZone: string;
  public isOpenTO: boolean = false;
  public selectedTransportOrder: TransportOrder;
  public selectedTransportOrderId: string;

  public loadingSpinner = false;

  public wizard = {
    code: "",
    manuallySelectOrderline: false,
    wizardDefinition: null,
    targetType: 1,
    orderlines: []
  }
  public openingScreen = 'TO-Screen-Details';
  public tableData: GridDataResult;
  destroy$ = new Subject();
  isCollapsed: boolean;
  constructor(private readonly toScreenService: ToScreenService,
    private readonly actionWizardService: ActionWizardService,
    private readonly httpClientService: HttpClientService,
    private readonly sharedActions: SharedActions,
    private readonly toActions: ToActions,
    private readonly simpleModalService: SimpleModalService,
    private readonly toActionBarService: ToActionBarService,
    private readonly pbScreenService: PbScreenService,
    private mapService: MapService,
    private readonly userFeedbackService: UserFeedbackService,
  ) {

    super();
  }
  ngOnDestroy(): void {
    this.selectedTransportOrder = null;
    this.selectedTransportOrderId = null;
    this.orderLines = [];
    this.destroy$.next();
    this.destroy$.complete();
  }
  ngOnInit(): void {
    this.toActions.setSelectedOrderlines([]);

    this.loading$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.loadingSpinner = data;
    });


    this.loadingSpinner = true;
    if(!this.selectedTransportOrderId || this.selectedTransportOrderId =="") {
      this.userFeedbackService.showErrorMessage("SELECTION_DISPLAY.TO_EMPTY_SELECTION");
      this.closeModal();
      return;
    }

    this.selectedOrderlines$?.pipe(takeUntil(this.destroy$)).subscribe(lines => {
      let hasOrderlineSelection = Array.isArray(lines) && lines.length > 0;

      if (hasOrderlineSelection) {
        this.loadingSpinner = true;
        this.pbScreenService.getPlanningBlocksByIds(lines.map(el => el.planningBlockId))
          .subscribe((result) => {
            console.log("getPlanningBlocksByIds", result);
            this.hasOrderlineSelection = hasOrderlineSelection;
          this.selectedPlanningBlocks = result;
          this.loadingSpinner = false;
        });
      }else{
        this.hasOrderlineSelection = hasOrderlineSelection;
      }
    });



    this.refreshData();


    this.toWizardDefinitions$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.actionWizardsList = data;
    });

  }

  public onPlanningAction(data: TransportOrder[]){
    if (data && data.length > 0){
      this.selectedTransportOrderId = data[0].id;
    }

    this.refreshData();
  }
  public refreshData() {
    this.toScreenService.getTransportOrderById(this.selectedTransportOrderId, true).subscribe((data) => {
      if (data) {
        this.isOpenTO = false;
        this.toActions.setSelectedTransportOrders([data]);
        this.selectedTransportOrder = data;
        if (this.selectedTransportOrder) {
          this.finalizeCombi = this.selectedTransportOrder.finalizedCombi === 1 ? true : false;
          if (this.selectedTransportOrder.toOperationalStatusType == ToOperationalStatusType.Created && !this.selectedTransportOrder.truckNo && !this.selectedTransportOrder.haulierNo) {
            this.isOpenTO = true;
          } else {
            this.isOpenTO = false;
          }
          if (this.toLinesGrid)
          {
            this.toLinesGrid.fetchTransportOrderLines(this.selectedTransportOrder);
            this.toLinesGrid.setGridDimensions(false);
          }
          if(this.toActionBar) {
            this.toActionBar.setSelectedTransportOrder(this.selectedTransportOrder);
          }

        }
      } else {

        this.userFeedbackService.showErrorMessage("SHARED.ERRORS.TRANSPORT_ORDER_NOT_FOUND");
        this.closeModal();
      }
      this.loadingSpinner = false;

    }, (error) => {
      this.userFeedbackService.showErrorMessage("SHARED.ERRORS.TRANSPORT_ORDER_NOT_FOUND", [this.selectedTransportOrderId]);
      this.loadingSpinner = false;
      this.closeModal();
    });
  }

  ngAfterViewInit() {
    this.toLinesGrid.setGridDimensions(false);
  }

  startWizard() {
    if (!this.selectedActionWizard) {
      this.userFeedbackService.showWarningMessage("SHARED.PLEASE_SELECT_A_WIZARD");
    }

    if (this.selectedActionWizard.insertLines.indexOf("Action Code") > -1) {
      this.executeWizardWithoutModal();
    } else {
      this.simpleModalService.addModal(ToInsertActionWizardComponent).subscribe(() => {
      });
    }
  }

  selectChange(event) {
    this.selectedActionWizard = event;
    this.wizard.code = this.selectedActionWizard.code;
    this.wizard.wizardDefinition = this.selectedActionWizard;
    this.sharedActions.setSelectedActionWizard(this.selectedActionWizard);
  }

  executeWizardWithoutModal() {
    let insertLineContainsActionCode = this.wizard.wizardDefinition.insertLines.indexOf("Action Code");
    if (insertLineContainsActionCode > -1 || this.wizard.code === "START TO" || this.wizard.code === "STOP TO") {
      this.actionWizardService.getOrderlineForTransportOrder(this.selectedTransportOrder.id, this.wizard.code).subscribe((data: OrderLine) => {
        this.wizard.orderlines.push(data);
        this.wizard.orderlines.forEach((element) => {
          this.actionWizardService.getWizardLines(this.wizard.code, element.orderLineId).subscribe((data) => {
            data.forEach((wizardLine, index) => {
              if (data.length - 1 === index) {
                this.actionWizardService.executeWizard({
                  "code": this.wizard.code,
                  "orderLineIDs": element.orderLineId.toString(),
                  "calledFrom": this.wizard.targetType,
                  "addressList": data[0].addressNo
                }).subscribe(_ => {
                  this.userFeedbackService.showSuccessMessage("SHARED.WIZARD_SAVED", undefined, "SHARED.WIZARD_SAVED_TITLE");
                });
              }
            });
          });
        });
      });
    }
  }

  public onChange($event) {
    this.loadingSpinner = true;
    this.finalizeCombi = $event;
    let toNumbers = [];
    toNumbers.push(this.selectedTransportOrder.id)
    this.pbScreenService.updateFinalizedCombi(toNumbers, this.finalizeCombi).subscribe((data) => {
      this.sharedActions.updateTransportOrdersDisplay(data)
      this.userFeedbackService.showSuccessMessage("SHARED.FINALIZED_COMBI_UPDATE_SUCCEEDED");
      this.loadingSpinner = false;
    });
  }

  public closeModal(): void {
    this.refreshTableDisplay.emit();
    this.close();
  }

  handleCollapsed(isCollapsed: boolean) {
    this.isCollapsed = isCollapsed;
    this.toLinesGrid.setGridDimensions(isCollapsed);
  }

  protected readonly SelectionTypes = SelectionTypes;
}
export interface ToDetailsInput {
  selectedTransportOrderId: string;

}
